import { Route, Routes } from 'react-router-dom';
import { ID_FIELD } from '../form/FormConstants';
import { UserProfileDetail } from '../pages-admin';
import UserPasswordDetail from '../pages-admin/users/UserPasswordDetail';

export function UserPages() {
    const userProfilePath = `usersProfile/:${ID_FIELD}`;
    const userPasswordPath = `usersPassword/:${ID_FIELD}`;
    return (
        <Routes>
            <Route path={userProfilePath} element={<UserProfileDetail />} />
            <Route path={userPasswordPath} element={<UserPasswordDetail />} />
        </Routes>
    );
}
